import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
// import Loader from "../Components/Common/Loader";
import Loader from "../../components/NewView/Common/Loader";
// const CourseGirdComponent = React.lazy(() =>
//   import("../Components/RootComponents/CourseGirdComponent")
// );

const PublicCourseGirdComponent = React.lazy(() =>
    import("../../components/NewView/RootComponents/PublicCourseGirdComponent")
  );

const CourseGridPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>Курси та програми перекваліфікації | Yellow Hub</title>
          <meta
            name="description"
            content="Курси Yellow Hub для дітей, підлітків і дорослих: англійська, комп'ютерна грамотність, графічний дизайн, таргетинг, AI, офісні навички та перекваліфікація."
          />
          <meta
            name="keywords"
            content="курси Yellow Hub, перекваліфікація, безкоштовні курси Харків, графічний дизайн, таргетолог, штучний інтелект, англійська для дітей, комп'ютерна грамотність"
          />
          <link rel="canonical" href="https://yellowhub.com.ua/courses" />
          <meta property="og:title" content="Курси та програми Yellow Hub" />
          <meta
            property="og:description"
            content="Практичні курси, перекваліфікація та програми розвитку для дітей, підлітків і дорослих."
          />
          <meta property="og:url" content="https://yellowhub.com.ua/courses" />
        </Helmet>
        <PublicCourseGirdComponent />
      </Suspense>
    </Fragment>
  );
};

export default CourseGridPage;
